import {
    type FC
} from "react";
import type IDropdownMenuItemProps from "./type";
import DropdownMenuRow from "../row";

const DropdownMenuItem: FC<IDropdownMenuItemProps> = ({
    isCloseOnSelect = true,
    type = "neutral",
    ...props
}) => {
    return <DropdownMenuRow
        {...props}
        isCloseOnSelect={isCloseOnSelect}
        role="menuitem"
        type={type}
    />;
};
export default DropdownMenuItem;
